import {
  getProfilesPending, getProfilesSuccess, getProfilesError,
  getProfilePending, getProfileSuccess, getProfileError,
  updateProfilePending, updateProfileSuccess, updateProfileError,
  searchProfilesPending, searchProfilesSuccess, searchProfilesError,
  createProfilePending, createProfileSuccess, createProfileError,
  removeProfilePending, removeProfileSuccess, removeProfileError,setProfileIndexSuccess
} from '../actions/profile';
import {ProfileService, UserService} from '../../lib/qc-api-client';
import {uploadResume} from './resume';

export function setProfileIndex(indexObject) {
  return (dispatch) => {
    dispatch(setProfileIndexSuccess(indexObject));
    return indexObject;
  };
}

export function getProfiles(userId) {
  return dispatch => {
    dispatch(getProfilesPending());
    ProfileService.getProfilesByUser(userId).then(response => {
      dispatch(getProfilesSuccess({
        profiles:       response.data.profiles,
        totalProfiles:  response.data.total,
      }));
      return response.data.profiles;
    }).catch(error => {
      console.error(error)
      dispatch(getProfilesError(error));
    })
  }
}

export function searchProfiles(keywords, location, options) {
  return dispatch => {
    dispatch(searchProfilesPending());
    ProfileService.searchProfiles(keywords, location, options).then(response => {
      dispatch(searchProfilesSuccess({
        profiles:       response.data.profiles,
        filters:    response.data.meta.filters,
        totalProfiles:  response.data.total,
        profilesLoaded: true
      }));
      return response.data.profiles;
    }).catch(error => {
      console.error(error)
      dispatch(searchProfilesError(error));
    })
  }
}

export function updateProfile(user, profile, resume = null, name) {
  return (dispatch) => {
    dispatch(updateProfilePending());
    ProfileService.update(user, profile, resume)
      .then((response) => {
        resume && uploadResume(user.id, profile.id, resume, name)(dispatch);
        dispatch(
          updateProfileSuccess({
            profile: response.data.profile,
          })
        );
        return response.data.profile;
      })
      .catch((error) => {
        console.error(error);
        dispatch(updateProfileError(error.message));
      });
  };
}

export function createProfile(user, profile, resume) {
  return dispatch => {
    dispatch(createProfilePending());
    ProfileService.create(user, profile, resume).then(response => {
      dispatch(createProfileSuccess({
        profile: response.data.profile
      }));
      return response.data.profile;
    }).catch(error => {
      console.error(error)
      dispatch(createProfileError(error));
    })
  }
}

export function getProfile(id) {
  return dispatch => {
    dispatch(getProfilePending());
    ProfileService.getProfile(id).then(response => {
      dispatch(getProfileSuccess({
        profile: response.data.profile
        //profile: mapResponseToParams(response.data.profile)
      }));
      return response.data.profile;
    }).catch(error => {
      console.error(error)
      dispatch(getProfileError(error));
    })
  }
}

export function removeProfile(user, profile) {
  return dispatch => {
    dispatch(getProfilePending());
    UserService.removeProfile(user, profile).then(response => {
      dispatch(removeProfileSuccess({
        profile: response.data.profile
      }));
      return response.data.profile
    }).catch(error => {
      console.error(error)
      dispatch(getProfileError(error));
    })
  }
}

function mapResponseToParams(profile) {
  return({
    id: profile && profile.id,
    relocate: profile ? profile.relocate : false,
    veteran: profile ? profile.veteran : false,
    resume: profile ? profile.resume : [],
    clearance: profile ? profile.securityClearance : false,
    citizen: profile ? profile.usCitizen : false,
    skillSets: profile ? profile.skillSets : [],
    workExperiences: profile ? profile.workExperiences : [],
    educations: profile ? profile.educations : '',
    searchable: profile ? profile.searchable : true,
    primary: profile ? profile.primary : true,
    title: profile && profile.title && profile.title || '',
    salary: profile ? profile.salary || 0 : 0,
    hourlyRate: profile ? profile.hourlyRate || 0 : 0,
  })
}
